/**
 * hub.coranchers.com API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface InvTranFulfillCustomerOrderDetResponseModel { 
    customerOrderDetId?: number;
    customerOrderId?: number;
    itemNumber?: string | null;
    itemDescription?: string | null;
    itemScanRequiered?: boolean;
    fulfillmentState?: number;
    fulfillmentOrdinal?: number;
    customerOrderUOfM?: string | null;
    customerOrderUnits?: string | null;
    notes?: string | null;
    invTranDetId?: number | null;
    workOrderUOfM?: string | null;
    workOrderUnits?: string | null;
    workOrderQuantity?: string | null;
    availableCount?: string | null;
    linkFulfillStatusColor?: string | null;
    linkFulfillStatusForegroundColor?: string | null;
}

